var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "7px",
    viewBox: "0 0 13 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7ADBFDCE-47E1-4E7E-8DAC-E09C2E5B1541") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---13---View-details--1",
    transform: "translate(-1149.000000, -218.000000)",
    fill: "#605F5E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(223.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(30.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-3",
    transform: "translate(902.300684, 26.495455) rotate(180.000000) translate(-902.300684, -26.495455) ",
    points: "908.601368 23.6235522 907.95579 23 902.367516 28.7218586 896.623393 23.1335842 896 23.7569774 902.367516 29.990909"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.db8c1f455d67e8d7f120738fde9a01a9.svg";
export { ForwardRef as ReactComponent };